module.exports = __webpack_public_path__ + "static/media/a_big-score.de33bc4b.png";